import React from 'react';
import { FlexGrid, Box } from '@alinta-digital/asg';
import { Error } from '../../components/Error';
import { getErrorProps } from '../../utils';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const appStatePkg = require('@alinta-digital/myaccount-frontend-api-appstate');

const ErrorPage: React.FC<any> = () => {
  const appState = appStatePkg.getAppState();
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const errorType = urlParams.get('errorType');
  const returnLink = urlParams.get('link');

  const handleBtnClick = () => {
    switch (errorType) {
      default:
        appState.navigateTo(appState.overviewLink.name);
        break;
    }
  };

  const errorProps = getErrorProps(errorType, returnLink, handleBtnClick);

  return (
    <FlexGrid direction="column" wrap="nowrap" alignItems="stretch" margin="none">
      <Box width="100%" maxWidth="1088px" margin={{ horizontal: 'auto' }}>
        <Error {...errorProps} data-testid="errorpage" />
      </Box>
    </FlexGrid>
  );
};

export default ErrorPage;
